import { SxProps, Theme } from "@mui/material";

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const eyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.78rem",
  fontWeight: 700,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
  mb: 2,
};

export const glassmorphismCard: SxProps<Theme> = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "16px",
  backdropFilter: "blur(12px)",
};

export const heroSection: SxProps<Theme> = {
  minHeight: "100vh",
  position: "relative",
  backgroundImage: "url('/img/assets/house4.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  px: 2,
  overflow: "hidden",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(32px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 70% 80% at 50% 50%, rgba(5,12,35,0.72) 0%, rgba(5,12,35,0.35) 50%, transparent 100%)",
  zIndex: 0,
  pointerEvents: "none",
};

export const heroTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to bottom, rgba(5,12,35,0.7), transparent)",
  zIndex: 1,
  pointerEvents: "none",
};

export const heroBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "380px",
  background: "linear-gradient(to bottom, transparent 0%, rgba(10,15,30,0.6) 50%, #0a0f1e 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const heroEyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.78rem",
  fontWeight: 700,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
  mb: 2,
  animation: "fadeUp 0.7s ease 0.1s both",
};

export const heroTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.8rem", md: "4.5rem" },
  color: "white",
  lineHeight: 1.1,
  mb: 3,
  animation: "fadeUp 0.7s ease 0.25s both",
};

export const heroSubtitle: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.1rem", md: "1.3rem" },
  color: "rgba(255,255,255,0.82)",
  mb: 1.5,
  animation: "fadeUp 0.7s ease 0.4s both",
};

export const heroTagline: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.1rem" },
  color: "rgba(255,255,255,0.5)",
  mb: 5,
  animation: "fadeUp 0.7s ease 0.5s both",
};

export const ctaButton: SxProps<Theme> = {
  bgcolor: "#f97316",
  color: "white",
  borderRadius: "50px",
  px: 5,
  py: 1.5,
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  textTransform: "none",
  "&:hover": { bgcolor: "#ea6c0a", color: "white" },
};

export const heroEarningsLabel: SxProps<Theme> = {
  mt: 3,
  display: "inline-flex",
  alignItems: "baseline",
  gap: 1.5,
  animation: "fadeUp 0.7s ease 0.7s both",
};

export const heroEarningsText: SxProps<Theme> = {
  color: "rgba(255,255,255,0.75)",
  fontFamily: "'Barlow', sans-serif",
  fontWeight: 400,
  fontSize: "1rem",
};

export const earningsSection: SxProps<Theme> = {
  bgcolor: "#0a0f1e",
  py: { xs: 12, md: 18 },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  overflow: "hidden",
};

export const earningsTextColumn: SxProps<Theme> = {
  flex: "0 0 auto",
  width: { xs: "100%", md: "52%" },
  pl: { xs: 4, sm: 6, md: 10, lg: 16 },
  pr: { xs: 4, sm: 6, md: 6 },
  py: { xs: 6, md: 0 },
};

export const earningsHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "4rem" },
  color: "white",
  lineHeight: 1.1,
  mb: 3,
};

export const earningsDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.15rem" },
  color: "rgba(255,255,255,0.82)",
  mb: 6,
  lineHeight: 1.65,
};

export const earningsCards: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const earningsCard: SxProps<Theme> = {
  ...glassmorphismCard,
  py: 4,
  px: 4,
  maxWidth: 380,
  textAlign: "center",
};

export const earningsCardAmount: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  fontSize: { xs: "3rem", md: "3.8rem" },
  fontWeight: 800,
  fontFamily: "'Poppins', sans-serif",
  lineHeight: 1,
  mb: 1,
};

export const earningsCardLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.5)",
  mb: 2,
};

export const earningsCardDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.6)",
  fontSize: "0.9rem",
  lineHeight: 1.6,
};

export const earningsImageWrapper: SxProps<Theme> = {
  flex: 1,
  position: "relative",
  alignSelf: "stretch",
  minHeight: { xs: 360, md: 600 },
  display: "flex",
  alignItems: "stretch",
};

export const earningsImage: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "left center",
  display: "block",
  position: "relative",
  zIndex: 1,
};

export const howItWorksHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.5rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
};

export const stepsContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: { xs: 6, md: 0 },
  position: "relative",
};

export const stepsConnectorLine: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  position: "absolute",
  top: "40px",
  left: "12.5%",
  right: "12.5%",
  height: "1px",
  background: "linear-gradient(to right, rgba(56,189,248,0.15), rgba(56,189,248,0.35), rgba(56,189,248,0.15))",
  zIndex: 0,
};

export const stepNumber: SxProps<Theme> = {
  fontSize: { xs: "3.5rem", md: "4.5rem" },
  fontWeight: 800,
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1,
  mb: 2,
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const stepTitle: SxProps<Theme> = {
  fontWeight: 700,
  color: "white",
  mb: 1.5,
  fontFamily: "'Barlow', sans-serif",
};

export const stepDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.65,
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.95rem",
};

export const ctaSection: SxProps<Theme> = {
  position: "relative",
  py: { xs: 18, md: 28 },
  minHeight: { md: "70vh" },
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  backgroundImage: "url('/img/assets/Ambassador2.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  overflow: "hidden",
};

export const ctaTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "340px",
  background: "linear-gradient(to bottom, #0a0f1e 0%, rgba(10,15,30,0.6) 55%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 60% 70% at 50% 50%, rgba(5,12,35,0.85) 0%, rgba(5,12,35,0.4) 50%, rgba(5,12,35,0.05) 100%)",
  zIndex: 0,
  pointerEvents: "none",
};

export const ctaHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.2rem" },
  color: "white",
  mb: 2,
};

export const ctaDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.15rem" },
  color: "rgba(255,255,255,0.82)",
  mb: 6,
};
